import Highcharts from "highcharts";
import hcMore from "highcharts/highcharts-more";
import React from "react";
import { InsHighcharts } from "../../base/insHighcharts";
import "./insBubbleChart.scss";
import { InsQueryStatedElement } from "components/widgets/base/insQueryStatedElement";
import { useCurrentWidgetState, useWidgetComponentProps } from "components/widgets/hooks/use-current-widget";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
import { SeriesType } from "hooks/widget-data/datapoints-api/visitors/custom/bubbleChart";
import { renderToStaticMarkup } from "react-dom/server";
import { formatTooltipData } from "./helpers";
import { yAxisFormatter2 } from "../insHorizontalBarChart/ins-horizontal-bar-chart-formatter";
import { mapValueFormatToCommonFormat } from "../base/utils";
hcMore(Highcharts);
const Tooltip = ({ tooltipData }) => React.createElement(React.Fragment, null, tooltipData?.map((item) => React.createElement(React.Fragment, { key: item[0] }, item[1] && React.createElement("div", { className: "ins-bubble-chart-tooltip-item" },
    React.createElement("span", null, item[0]),
    React.createElement("span", null, item[1])))));
export const InsBubbleChart = (props) => {
    const { index, isMaximizedOne, sectionId, widgetId } = props, widgetProps = useWidgetComponentProps(sectionId, widgetId), widgetState = useCurrentWidgetState(sectionId, widgetId);
    const { colorSet, credits, dataSelectProps, showLegend, xDisplayName } = widgetProps;
    const selectedValues = widgetState?.selectedValues ?? [];
    const selectedDropDownProps = Object.entries(selectedValues).map(([key, value]) => dataSelectProps[parseInt(key, 10)].selectValues[value]);
    const [[rawResult], queryState, refresh] = useGetDatapointsWidgetData(props), [result] = rawResult?.data || [], { series } = result || {
        hasColorDimension: false,
        hasData: false,
        items: [],
        series: []
    };
    const yDisplayName = selectedDropDownProps[0]?.displayName || "";
    const options = {
        chart: {
            styledMode: true,
            type: SeriesType.Bubble
        },
        credits,
        legend: { align: "left", enabled: showLegend },
        plotOptions: {
            bubble: {
                dataLabels: {
                    allowOverlap: false,
                    className: "ins-bubble-chart-data-label",
                    enabled: true,
                    format: "{point.name}"
                },
                maxSize: 50,
                minSize: 10
            },
            series: {
                marker: {
                    enabled: true
                }
            }
        },
        series,
        title: {
            text: ""
        },
        tooltip: {
            formatter() {
                const datapoint = this.point;
                const tooltipData = formatTooltipData(datapoint, selectedDropDownProps);
                return renderToStaticMarkup(React.createElement(Tooltip, { tooltipData: tooltipData }));
            },
            useHTML: true
        },
        xAxis: {
            minorTickInterval: 0,
            title: {
                text: xDisplayName
            }
        },
        yAxis: {
            endOnTick: false,
            labels: {
                enabled: true,
                formatter() {
                    const format = selectedDropDownProps.length ? mapValueFormatToCommonFormat(selectedDropDownProps[0]?.valueFormat) : undefined;
                    return yAxisFormatter2(this, false, undefined, format);
                },
                useHTML: true
            },
            min: 0,
            startOnTick: false,
            title: {
                text: yDisplayName
            }
        }
    };
    return React.createElement(InsQueryStatedElement, { widgetFactoryProps: props, queryState: queryState, hasData: result?.series.length > 0 },
        React.createElement(InsHighcharts, { key: `${sectionId}-${widgetId}-${index}`, options: options, colorSet: colorSet, sectionId: sectionId, widgetId: widgetId, refreshAction: refresh, isMaximizedOne: isMaximizedOne }));
};
